<template>
    <div class="upcAdministration">
        <h3 class="border-bottom">
            系统中UPC码现在共有
            <span>{{ UPCNum }}</span>
            条，EAN码共有
            <span>{{ EANNum }}</span>
            条
        </h3>
        <div class="tips margin-top1">
            <span>
                添加新的UPC、EAN编码，把准备好的UPC、EAN编码粘贴到下面的文本框中，然后点击立即添加。系统已经添加过的数据会被忽略。
            </span>
            <!-- <p>注意：每条记录必需要用英语逗号[,]分割</p> -->
        </div>
        <el-row>
            <el-button type="primary" @click="enableUPCEAN('UPC')">启用本公司UPC码池</el-button>
            <el-button type="primary" @click="enableUPCEAN('EAN')">启用本公司EAN码池</el-button>
            <el-button type="danger" @click="enableUPCEAN('close')" :disabled="idDisabled === 0">关闭码池</el-button>
        </el-row>
        <div class="uplist margin-top1">
            <div class="upwlift">
                <div class="upc_text">添加UPC码</div>
                <el-input
                    type="textarea"
                    :autosize="{ minRows: 10, maxRows: 10 }"
                    placeholder="请输入内容"
                    v-model="UPCtextarea"
                ></el-input>
                <div class="margin-top1">
                    <el-button
                        type="primary"
                        @click="addCode('UPC')"
                        :loading="loading === 'UPC'"
                        :disabled="idDisabled !== 2"
                    >
                        立即添加UPC
                    </el-button>
                    <el-button
                        type="danger"
                        style="float:right;"
                        :loading="loading === 'delUPC'"
                        @click="delCode('UPC')"
                        :disabled="idDisabled !== 2 || UPCNum === 0"
                    >
                        清空UPC码
                    </el-button>
                </div>
            </div>
            <div class="upwlift margin-left4">
                <div class="upc_text">添加EAN码</div>
                <el-input
                    type="textarea"
                    :autosize="{ minRows: 10, maxRows: 10 }"
                    placeholder="请输入内容"
                    v-model="EANtextarea"
                ></el-input>
                <div class="margin-top1">
                    <el-button
                        type="primary"
                        @click="addCode('EAN')"
                        :loading="loading === 'EAN'"
                        :disabled="idDisabled !== 1"
                    >
                        立即添加EAN
                    </el-button>
                    <el-button
                        type="danger"
                        style="float:right;"
                        :loading="loading === 'delEAN'"
                        @click="delCode('EAN')"
                        :disabled="idDisabled !== 1 || EANNum === 0"
                    >
                        清空EAN码
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import {
//     getUPCNum,
//     addUPCCode,
//     getEANNum,
//     addEANCode
// } from "@/api/apis/upcAdministration";

import { ajaxPost, Baseurl } from "@/api/api/api";

export default {
    name: "upcAdministration",
    data() {
        return {
            UPCNum: 0,
            EANNum: 0,
            EANtextarea: "",
            UPCtextarea: "",
            loading: "",
            UserInfo: {},
        };
    },
    created() {
        this.UserInfo = JSON.parse(localStorage.getItem("role"));
        this.getUPCNum();
        this.getEANNum();
    },
    computed: {
        idDisabled() {
            return this.UserInfo.company.isEanSet;
        },
    },
    methods: {
        getUPCNum() {
            const API = Baseurl + "upcController/selectUsableUpc";
            const paramsData = {
                companyId: this.UserInfo.company_id,
            };
            ajaxPost(API, paramsData)
                .then(res => {
                    const { code, data } = res.data;
                    if (code === 200) {
                        this.UPCNum = data;
                    }
                })
                .catch(() => {
                    new Error("UPC码数量请求出错");
                });
        },
        getEANNum() {
            const API = Baseurl + "amazonEan/selectUsableEan";
            const paramsData = {
                companyId: this.UserInfo.company_id,
            };
            ajaxPost(API, paramsData)
                .then(res => {
                    const { code, data } = res.data;
                    if (code === 200) {
                        this.EANNum = data;
                    }
                })
                .catch(() => {
                    new Error("EAN码数量请求出错");
                });
        },
        addCode(type) {
            if (!this[`${type}textarea`]) {
                this.$message.warning(`请输入${type}码`);
                return;
            }
            const requestFn = () => {
                let API = "";
                const paramsData = {
                    companyId: this.UserInfo.company_id,
                };
                const operate = {
                    UPC: () => {
                        this.loading = "UPC";
                        API = Baseurl + "upcController/insertUpc";
                        paramsData.data = this.UPCtextarea;
                        // return addUPCCode;
                        return ajaxPost;
                    },
                    EAN: () => {
                        this.loading = "EAN";
                        API = Baseurl + "amazonEan/insertEan";
                        paramsData.data = this.EANtextarea;
                        // return addEANCode;
                        return ajaxPost;
                    },
                };

                operate[type]()(API, paramsData)
                    .then(res => {
                        const { code, data } = res.data;
                        this.loading = "";
                        if (code === 200) {
                            if (type === "UPC") {
                                this.UPCtextarea = "";
                                this.getUPCNum();
                            } else if (type === "EAN") {
                                this.EANtextarea = "";
                                this.getEANNum();
                            }
                            this.$message.success(data);
                        } else {
                            this.$message.error(data);
                        }
                    })
                    .catch(() => {
                        new Error(`${type}码添加出错`);
                    });
            };
            this.$confirm(`此操作添加${type}码, 是否继续?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
            })
                .then(() => {
                    requestFn();
                })
                .catch(() => {
                    new Error(`${type}码添加出错`);
                });
        },
        delCode(type) {
            const requestFn = () => {
                let API = "";
                const paramsData = {
                    companyId: this.UserInfo.company_id,
                };
                const operate = {
                    UPC: () => {
                        this.loading = "delUPC";
                        API = Baseurl + "upcController/deleteUsableUpc";
                    },
                    EAN: () => {
                        this.loading = "delEAN";
                        API = Baseurl + "amazonEan/deleteUsableEan";
                    },
                };
                operate[type]();
                ajaxPost(API, paramsData)
                    .then(res => {
                        const { code, data } = res.data;
                        this.loading = "";
                        if (code === 200) {
                            if (type === "UPC") {
                                this.getUPCNum();
                            } else if (type === "EAN") {
                                this.getEANNum();
                            }
                            this.$message.success(data);
                        } else {
                            this.$message.error(data);
                        }
                    })
                    .catch(() => {
                        new Error(`${type}码添加出错`);
                    });
            };
            this.$confirm(`此操作将清空${type}码, 是否继续?`, "提示")
                .then(() => {
                    requestFn();
                })
                .catch(() => {
                    new Error(`${type}码清空出错`);
                });
        },
        async enableUPCEAN(type) {
            const API = Baseurl + "companyController/updateIsEanSet";
            const paramsData = {
                id: this.UserInfo.company_id,
            };
            if (type === "UPC") {
                paramsData.isEanSet = 2;
            } else if (type === "EAN") {
                paramsData.isEanSet = 1;
            } else if (type === "close") {
                paramsData.isEanSet = 0;
            }
            const {
                data: { code, data },
            } = await ajaxPost(API, paramsData);
            if (code === 200) {
                this.UserInfo.company.isEanSet = data.isEanSet;
                localStorage.setItem("role", JSON.stringify(this.UserInfo));
                this.$message.success("操作成功");
            } else {
                this.$message.warning("操作失败");
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.upcAdministration {
    width: 98%;
    h3 {
        line-height: 40px;
        span {
            color: red;
        }
    }
    .tips {
        span {
            line-height: 40px;
        }
        p {
            color: #ff7575;
        }
    }
    .upwlift {
        overflow: hidden;
        width: 48%;
        float: left;
        .upc_text {
            line-height: 30px;
        }
    }
}
</style>
